/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Dialog_Chapter_CountInputs */

const en_dialog_chapter_count = /** @type {(inputs: Dialog_Chapter_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`No chapters`);
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} chapter`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} chapters`);
	return /** @type {LocalizedString} */ ("dialog_chapter_count");
};

const es_dialog_chapter_count = /** @type {(inputs: Dialog_Chapter_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Sin capítulos`);
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} capítulo`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} capítulos`);
	return /** @type {LocalizedString} */ ("dialog_chapter_count");
};

/**
* | count | countPlural | output |
* | --- | --- | --- |
* | "0" | * | "No chapters" |
* | * | "one" | "{count} chapter" |
* | * | "other" | "{count} chapters" |
*
* @param {Dialog_Chapter_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_chapter_count = /** @type {((inputs: Dialog_Chapter_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Chapter_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_chapter_count(inputs)
	return en_dialog_chapter_count(inputs)
});